import { Component, Input } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { AccessRights, USER_ROLE, User, getRoleList } from "../../common/user";
import { OrganisationService } from "../organisation.service";
import { UserService } from "../../user/user.service";

@Component({
    selector: 'app-user-access',
    styleUrls: ['./user-access.css'],
    templateUrl: 'user-access.html',
    standalone: false
})
export class UserAccessComponent {
    @Input() userAccess:AccessRights[]
    
    users: any[]
    roles: any[]
    usersDataSource:MatTableDataSource<User>
    errorMessage: string = undefined

    displayedColumns: string[] = ['name', 'email', 'role'];

    constructor(private organisationService:OrganisationService, private userService:UserService) {
        this.roles = getRoleList()
    }

    ngOnInit() {
        const allUsers = this.organisationService.users || []
        this.users = allUsers.map(u => {
            const access = this.userAccess && this.userAccess.find(a => a.userKey === u._key)
            return {
                _key:u._key,
                name:u.name,
                email:u.email,
                role: access && access.access
            }
        })
        this.usersDataSource = new MatTableDataSource(this.users)
    }

    isValid() {
        const valid = this.users.find(u => u.role === USER_ROLE.ADMIN)
        if (!valid) this.errorMessage = "You must have at least one admin user"
        else this.errorMessage = undefined

        return valid
    }

    getUserAccess() {
        return this.users.filter(u => u.role !== undefined).map(u => {
            return {
                access: u.role,
                userKey: u._key,
                activated: true
            } as AccessRights
        })
    }
}